import { render } from "./navbar.vue?vue&type=template&id=80e15ac4&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=80e15ac4&scoped=true&lang=css"
import "./navbar.vue?vue&type=style&index=1&id=80e15ac4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e15ac4"]])

export default __exports__